import { uiWaitCallback } from '../ui/functions';
import { $log } from './debug';
import { yNewUniqueId } from './util';

export interface OAuth2Params {
    response_type: 'code' | 'token';
    client_id: string;
    redirect_uri: string;
    scope: string;
    state?: string;
    account_type?: string;
    access_type?: string;
}

function paramsAsQuery(params: any) {
    return Object.keys(params).map(k => k + '=' + encodeURIComponent(params[k])).join('&');
}

interface OAuth2Response {
    code: string;
    state: string;
    access_token: string;
}

export function oauth(auth_url: string, params: OAuth2Params) {
    if(!params.state)
        params.state = yNewUniqueId('bli', 12, 16);

    $log('callback', 'params', params);

    auth_url = auth_url + '?' + paramsAsQuery(params);

    return uiWaitCallback<OAuth2Response>(auth_url, { width: 540, height: 720 }).then(response => {
        if(response.form.state != params.state)
            throw 'Invalid state';
        if(!response.form.code)
            throw 'Invalid code';

        return response.form.code || response.form.access_token;
    });
}
